import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { is, equals } from 'ramda';
import { FormattedMessage } from 'react-intl';

import EnhancedButton from 'material-ui/internal/EnhancedButton';
import Paper from 'material-ui/Paper';
import { wrapper, gradeIndicator, noBorder, selection, selected } from './Grade.less';

import smileyUp from './assets/smiley-up.svg';

const Grade = ({ isSelected, grade, text, description, onSelect }) => (
  <div className={wrapper + (isSelected ? ' ' + selected : '')}>
    <EnhancedButton
      onClick={onSelect}
      style={{ width: '100%', textAlign: 'left', overflow: 'visible', paddingLeft: '1.75rem' }}
    >
      <Paper className={selection}>
        <Row style={{ height: '100%' }} middle="xs">
          <Col xs={2} sm={1} style={{ maxWidth: '3.5rem' }}>
            <div className={gradeIndicator + ' ' + (equals(grade, 0) ? noBorder : '')}>
              {is(Number, grade) && grade > 0 && grade}
              {equals(grade, 0) && <img alt="0" src={smileyUp} />}
            </div>
          </Col>
          <Col xs={10} sm={11}>
            <h6 className="bold">
              {text && text}
              {!text && <FormattedMessage id="status.notAnswered" />}
            </h6>
            {description && <ul dangerouslySetInnerHTML={{ __html: description }} />}
          </Col>
        </Row>
      </Paper>
    </EnhancedButton>
  </div>
);

Grade.propTypes = {
  grade: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isSelected: PropTypes.bool,
  text: PropTypes.string,
  description: PropTypes.string,
  onSelect: PropTypes.func,
};

export default Grade;
